import { j as e } from "../../../_virtual/jsx-runtime.js";
import { Route as o } from "react-router-dom";
import i from "./Login.js";
import m from "./Register.js";
import n from "./comps/Layout.js";
function l(r) {
  const { logo: t, onSuccess: s } = r;
  return /* @__PURE__ */ e.jsxs(o, { element: /* @__PURE__ */ e.jsx(n, {}), children: [
    /* @__PURE__ */ e.jsx(o, { path: "/login", element: /* @__PURE__ */ e.jsx(i, { logo: t, onSuccess: s }) }, "login"),
    /* @__PURE__ */ e.jsx(o, { path: "/register", element: /* @__PURE__ */ e.jsx(m, { logo: t }) }, "register")
  ] });
}
export {
  l as createAuthRoutes
};
